import { DashboardLayout } from "@/components/DashboardLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Construction } from "lucide-react";

interface ComingSoonPageProps {
  title: string;
  description?: string;
}

export default function ComingSoonPage({ title, description }: ComingSoonPageProps) {
  return (
    <DashboardLayout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="max-w-md w-full text-center border-dashed">
          <CardContent className="pt-10 pb-10 space-y-4">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-muted">
              <Construction className="h-7 w-7 text-muted-foreground" />
            </div>
            <div className="space-y-2">
              <h1 className="font-display text-2xl font-bold text-foreground">{title}</h1>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {description ?? "This feature is currently under development. Stay tuned — it's coming soon!"}
              </p>
            </div>
            <div className="inline-flex items-center rounded-full bg-muted px-3 py-1 text-xs font-medium text-muted-foreground">
              Coming Soon
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
